var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('b-avatar',{staticClass:"flex-shrink-0 mr-2",attrs:{"src":_vm.params.avatar,"size":"30px"},on:{"click":function($event){return _vm.$router.push(_vm.url)}}}),_c('span',[_vm._v(_vm._s(_vm.params))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }